import { render, staticRenderFns } from "./UsedEntitlement.vue?vue&type=template&id=4faf0c7a&scoped=true&"
import script from "./UsedEntitlement.vue?vue&type=script&lang=js&"
export * from "./UsedEntitlement.vue?vue&type=script&lang=js&"
import style0 from "./UsedEntitlement.vue?vue&type=style&index=0&id=4faf0c7a&prod&lang=scss&scoped=true&"
import style1 from "./UsedEntitlement.vue?vue&type=style&index=1&id=4faf0c7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf0c7a",
  null
  
)

export default component.exports